<div class="staff-content">
  <div class="card">
    <div class="question">Haven’t hired your onsite staff yet?</div>
    <div class="desc">MICEtribe marketplace allows you to hire event freelancers for your upcoming events.</div>
    <div class="note">We are working hard to bring this feature to you as soon as we can.</div>
  </div>
</div>
